/**
 * Мониторинг через PostHog: аналитика + error tracking
 */

const POSTHOG_KEY = (import.meta.env.VITE_POSTHOG_KEY as string | undefined) ?? 'phc_jKFS64lWTu6aTmjlS9L1WW8t2Da7A811xAnsTuyjovI';
const POSTHOG_HOST = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? 'https://eu.i.posthog.com';

let posthogInitialized = false;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let posthogInstance: any = null;

export async function initMonitoring() {
  if (POSTHOG_KEY && !posthogInitialized) {
    try {
      const { default: posthog } = await import('posthog-js');
      posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        persistence: 'localStorage', // Сохраняем distinct_id между сессиями для A/B тестов и воронок
        autocapture: false, // Только явные события
        capture_pageview: false,
        disable_session_recording: false, // Включаем session recording
        capture_exceptions: true, // Автоматически перехватываем unhandled errors
      });
      posthogInstance = posthog;
      posthogInitialized = true;

      // Belt & suspenders: перехватываем unhandledrejection вручную
      window.addEventListener('unhandledrejection', (event) => {
        captureError(event.reason, { context: 'unhandledRejection' });
      });
    } catch {
      // PostHog не критичен — игнорируем ошибки инициализации
    }
  }
}

// Трекинг ошибки (PostHog exception)
export function captureError(error: unknown, context?: Record<string, unknown>) {
  if (!posthogInitialized || !posthogInstance) return;
  try {
    posthogInstance.captureException(error, { properties: context });
  } catch {
    // не критично
  }
}

// Трекинг события (PostHog)
export function trackEvent(event: string, properties?: Record<string, unknown>) {
  if (!posthogInitialized || !posthogInstance) return;
  try {
    posthogInstance.capture(event, properties);
  } catch {
    // не критично
  }
}

// Идентификация пользователя в PostHog
export function identifyUser(userId: number) {
  if (!posthogInitialized || !posthogInstance) return;
  try {
    posthogInstance.identify(String(userId));
  } catch {
    // не критично
  }
}
